import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Persisted expanded/collapsed state for the app sidebar. Drives the shadcn
 * SidebarProvider in controlled mode so the choice survives reloads via
 * localStorage (replacing shadcn's cookie default).
 */
interface SidebarState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      open: true,
      setOpen: (open) => set({ open }),
    }),
    { name: "sidebar-state" },
  ),
);
